import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  spacing: { unit },
  typography: {
    fontWeight,
    smallLabel: { fontSize: smallLabelFontSize }
  }
}: ComposedTheme) => ({
  fdicDisclaimerText: {
    fontSize: smallLabelFontSize,
    padding: [0.5 * unit, 0],
    fontWeight,
    textTransform: 'none'
  }
});

export default createUseStyles(styles);
